import { useMemo } from 'react'

import { EXPERIMENT_SLUGS, experiments, featureFlags } from '@core/experiments'
import { useCurrentUser } from '@features/session'

import { CREATOR_PROFILE_OFFER_PAYWALL_REQUEST } from '../constants/paywallRequests'
import { markCreatorProfileOfferHandled } from '../helpers/creatorProfileOfferHandled'
import { usePaywallDialog } from './usePaywallDialog'

export const useShowCreatorProfileOffer = () => {
    const { id: userId } = useCurrentUser()
    const { open } = usePaywallDialog()

    return useMemo(
        () => () => {
            markCreatorProfileOfferHandled(userId)
            experiments.confirmParticipate(EXPERIMENT_SLUGS.CONTEXTUAL_PRO_OFFER_CREATOR)

            if (featureFlags.withCreatorProfileProOffer) {
                open(CREATOR_PROFILE_OFFER_PAYWALL_REQUEST)
            }
        },
        [userId, open],
    )
}
